export const SendOtp = async ({ BeURL, email, purpose }) => {
    try {
        const response = await fetch(`${BeURL}/send-otp`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email, purpose }),
        });

        // 👇 ALWAYS read response body first
        const data = await response.json();

        // 👇 THEN check status
        if (!response.ok) {
            return {
                success: false,
                message: data.message || "Failed to send OTP",
            };
        }
        return data;
    } catch (err) {
        console.log("SEND OTP SERVICE ERROR", err);
        return {
            success: false,
            message: "Server not reachable",
        };
    }
};
